import customAxios from "./axios";
import CONFIG from "../../config";

export const getAllJobs = ({ departmentId, processId, masterProcessId, companyName, page, selectedPaymentType, selectedPaymentStatus ,dueDateStart, dueDateEnd }) =>
  customAxios.get(`${CONFIG.apiURL}/CorporateCompanyJob/GetAllJobs?Department=${departmentId}
  &Process=${processId}&MasterProcess=${masterProcessId}&Company=${companyName}&page=${page}&PaymentType=${selectedPaymentType}&PaymentStatus=${selectedPaymentStatus}&DueDateStart=${dueDateStart}&DueDateEnd=${dueDateEnd}`);


export const getCorporateJobById = (id) =>
  customAxios.get(
    `${CONFIG.apiURL}/CorporateCompanyJob/GeJobDetail?requestId=${id}`
  );

export const convertToDraftJob = (documentId,cspId) =>
  customAxios.get(
    `${CONFIG.apiURL}/CorporateCompanyJob/ConvertToDraftJob?documentId=${documentId}&cspId=${cspId}`
  );

export const paymentApprovalForFinance = (payload) => {
  return customAxios.post(CONFIG.apiURL + '/CorporateCompanyJob/PaymentApprovalForFinance', payload).then((response) => {
      return response;
  });
};

export const recordCreditPaymentReceived = (payload) => {
  return customAxios.post(CONFIG.apiURL + '/CorporateCompanyJob/RecordCreditPaymentReceived', payload).then((response) => {
      return response;
  });
};

export const ExportCsv = (payload) => {
  const queryString = toQueryString(payload);
  return customAxios.get(CONFIG.apiURL + `/CorporateCompanyJob/ExportCsv?`+queryString).then(res => {
      return res;
  })
}

const toQueryString = (params) => {
  return Object.keys(params)
      .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(params[key]))
      .join('&');
};

export const GetCreditLimitDetailByCompany = (companyId) => {
  
  return customAxios.get(CONFIG.apiURL + `/CorporateCompanyJob/GetCreditLimitDetailByCompany?companyId=`+companyId).then(res => {
      return res;
  })
}